import { ConvexReactClient } from "convex/react";
import { ENV } from "@/env";

const convexUrl = ENV.CONVEX_URL;

if (!convexUrl) {
  throw new Error(
    "Missing Convex URL. Configure it in src/env.ts",
  );
}

export const convex = new ConvexReactClient(convexUrl);
